// School-language names supported by WAEC Ghana and the Bureau of Ghana Languages.
export const GHANAIAN_LANGUAGES = [
  "Akuapem Twi",
  "Asante Twi",
  "Fante",
  "Ewe",
  "Ga",
  "Dangme",
  "Dagaare",
  "Dagbani",
  "Gonja",
  "Kasem",
  "Nzema",
] as const;
export type GhanaianLanguage = (typeof GHANAIAN_LANGUAGES)[number];
export function readGhanaianLanguages(value: unknown): GhanaianLanguage[] {
  return Array.isArray(value)
    ? [
        ...new Set(
          value.filter((item): item is GhanaianLanguage =>
            GHANAIAN_LANGUAGES.includes(item),
          ),
        ),
      ].slice(0, 2)
    : [];
}
export function studiesGhanaianLanguage(subjects: string[] = []): boolean {
  return subjects.some(
    (subject) =>
      /ghanaian\s+language/i.test(subject) ||
      GHANAIAN_LANGUAGES.some(
        (language) => language.toLowerCase() === subject.trim().toLowerCase(),
      ),
  );
}
export function ghanaianLanguageScope(
  subject: string,
  selected: unknown,
): string {
  const languages = readGhanaianLanguages(selected);
  return /ghanaian\s+language/i.test(subject) && languages.length
    ? `${subject} (${languages.join(" and ")})`
    : subject;
}
